import styled from 'styled-components'

import { Star as SVGStar, StarVariants } from '../Svg/Star'

interface ButtonStarProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
  active?: boolean
  styleIcon?: React.CSSProperties
}


export const ButtonStar: React.FC<ButtonStarProps> = ({
  className,
  style,
  onClick,
  title,
  active,
  styleIcon,
}) => {
  let starVariant: StarVariants = 'outline'
  if (active) {
    starVariant = 'fill'
  }

  return (
    <Button
      onClick={onClick}
      title={title}
      className={className}
      style={style}
    >
      <SVGStar
        variant={starVariant}
        style={styleIcon || { width: 'max(24px, 1.6666667vw)' }}
      />
    </Button>
  )
}

const Button = styled.button`
  background: none;
  border: 0;
  border-radius: 0;
  margin: 0;
  padding: 0;
  width: max(45px,3.125vw);
  height: max(45px,3.125vw);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
